import {RadioChangeEvent} from 'antd';
import {useCallback, useMemo, useState} from 'react';

import {CatalogByGroupType} from '../../../../../service/source-settings/catalogs/catalogs-type';
import {SourceLinkTypeEnum} from '../../../../../service/source-settings/source-links/source-links-type';
import {getEnumValueEnsure} from '../../../../../util/enum';

import {isBrandOnlyReviewsCatalogId} from './header-alert/header-alert-hook';

type UseCatalogLinkTypeReturnType = {
    linkType: SourceLinkTypeEnum;
    onLinkTypeSelect: (event: RadioChangeEvent) => void;
};

export function useCatalogLinkType(activeCatalog: CatalogByGroupType | undefined): UseCatalogLinkTypeReturnType {
    const [activeLinkType, setActiveLinkType] = useState<SourceLinkTypeEnum>(SourceLinkTypeEnum.Brand);

    const linkType: SourceLinkTypeEnum =
        activeCatalog && isBrandOnlyReviewsCatalogId(activeCatalog.id) ? SourceLinkTypeEnum.Brand : activeLinkType;

    const onLinkTypeSelect = useCallback((event: RadioChangeEvent): void => {
        const selectedLinkType: SourceLinkTypeEnum = getEnumValueEnsure<SourceLinkTypeEnum>(
            SourceLinkTypeEnum,
            event.target.value,
            SourceLinkTypeEnum.Brand
        );

        setActiveLinkType(selectedLinkType);
    }, []);

    return useMemo<UseCatalogLinkTypeReturnType>(() => ({linkType, onLinkTypeSelect}), [linkType, onLinkTypeSelect]);
}
